import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { GraphNewAssignModalComponent } from '../graph-new-assign-modal/graph-new-assign-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { MessageModalComponent } from '../../message/message-modal.component';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { SensorTypeService } from 'src/app/services/sensor-type/sensor-type.service';
import { CausePlanCrudModalComponent } from './cause-plan-crud-modal/cause-plan-crud-modal.component';

@Component({
  selector: 'app-deviation-modal',
  templateUrl: './deviation-modal.component.html',
  styleUrls: ['./deviation-modal.component.css']
})
export class DeviationModalComponent implements OnInit {
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['graph','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  items = [];
  editItem: any = null;
  creating: boolean = false;
  newItemId: number = null;
  causes = [];
  actionPlans = [];

  constructor(
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private sensorTypeService: SensorTypeService,
  ) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.list();
  }

  startNewItem() {
  this.creating = true;
  this.data.title = 'Nueva Desviación asociado a '+ this.data.sensorType;
  this.editItem = { name: '' };
}

  
  list(){
    this.spinner.show();
    this.sensorTypeService.getListDeviation(this.data.idSensorType).subscribe((response) => {
      if(!response.error){
        this.dataSource.data = response.data;
      }else{
        this.dataSource.data = [];
      }

      this.spinner.hide();
    },
    (error: HttpErrorResponse) => {
        this.spinner.hide();
    });
  }

  edit(element: any) {
    this.editItem = { ...element }; // copia del elemento a editar
    this.data.title = `Editar Desviación: ${element.name}`;
    this.loadCausasAndPlanes(this.editItem.id);
  }

  cancelEdit(){
    this.editItem = null;
    this.creating = false;
    this.data.title = AppConstants.TitleModal.LIST_SENSOR_TYPE_DERIVATION + this.data.sensorType;
  }

  saveEdit() {
  const dataToSend = {
    name: this.editItem.name,
    id: this.editItem.id || 0,
    sensorTypeId: this.data.idSensorType
  };

  this.spinner.show();

  const obs = this.creating
    ? this.sensorTypeService.createDeviation(dataToSend)
    : this.sensorTypeService.updateDeviation(dataToSend);

  obs.subscribe(response => {
    this.spinner.hide();
    if (response.code == 200) {
      if (this.creating) {
        dataToSend.id = response.id;
        this.editItem = dataToSend; // viene con ID
        this.newItemId = response.id;
        this.creating = false;
        this.alertService.showMessage(AppConstants.MessageModal.CREATE, "", MessageSeverity.success);
        this.data.title = `Editar Desviación: ${dataToSend.name}`;
      } else {
        this.editItem = null;
        this.data.title = AppConstants.TitleModal.LIST_SENSOR_TYPE_DERIVATION + this.data.sensorType;
        this.alertService.showMessage(AppConstants.MessageModal.UPDATE, "", MessageSeverity.success);
        this.list();
      }
    }else{
      this.alertService.showMessage('Error', 'Error al guardar', MessageSeverity.error);
    }
  }, (error: HttpErrorResponse) => {
    this.spinner.hide();
    this.alertService.showMessage('Error', error.error.message || 'Error al guardar', MessageSeverity.error);
  });
}


  delete(element){
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
          title: AppConstants.TitleModal.DELETE_SENSOR_TYPE_DERIVATION,
          message: AppConstants.MessageModal.DELETE_CONFIRMATION_MESSAGE,
          hasButton: true,
          contentButton: {
              yes: 'SI',
              no: 'CANCELAR'
          }
      },
  })

  dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteDeviation(element.id);
      }
  });
  }

  deleteDeviation(id: number) {
    this.spinner.show();
    this.sensorTypeService.deleteDeviation(id).subscribe((response => {
      this.spinner.hide();
      this.alertService.showMessage(AppConstants.MessageModal.DELETE, "", MessageSeverity.success);
      this.list();
    }),
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(AppConstants.MessageModal.DELETE, "",  MessageSeverity.error);
        this.spinner.hide();
      });
  }

  close() {
    this.dialog.closeAll();
  }

  loadCausasAndPlanes(id: number) {
  this.sensorTypeService.getListDeviationCauses(id).subscribe(r => this.causes = r.data);
  this.sensorTypeService.getListDeviationPlans(id).subscribe(r => this.actionPlans = r.data);
}

openCauseModal(cause?: any) {
  const dialogRef = this.dialog.open(CausePlanCrudModalComponent, {
    data: {
      item: !cause ? null : cause,
      type: 'cause',
      idDeviation: this.editItem.id,
      color: this.data.color,
      colorFont: this.data.colorFont
    },
    width: '400px'
  });

  dialogRef.afterClosed().subscribe(res => {
    if (res && res.refresh) {
      this.loadCausasAndPlanes(this.editItem.id);
    }
  });
}

openPlanModal(plan?: any) {
const dialogRef = this.dialog.open(CausePlanCrudModalComponent, {
    data: {
      item: !plan ? null : plan,
      type: 'plan',
      idDeviation: this.editItem.id,
      color: this.data.color,
      colorFont: this.data.colorFont
    },
    width: '400px'
  });

  dialogRef.afterClosed().subscribe(res => {
    if (res && res.refresh) {
      this.loadCausasAndPlanes(this.editItem.id);
    }
  });
}


  confirmDeleteCause(id){
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
          title: AppConstants.TitleModal.DELETE_SENSOR_TYPE_DERIVATION_CAUSE,
          message: AppConstants.MessageModal.DELETE_CONFIRMATION_MESSAGE,
          hasButton: true,
          contentButton: {
              yes: 'SI',
              no: 'CANCELAR'
          }
      },
  })

  dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteCause(id);
      }
  });
  }

deleteCause(id: number) {
  this.sensorTypeService.deleteDeviationCause(id).subscribe(() => {
    this.loadCausasAndPlanes(this.editItem.id);
  });
}

  confirmDeleteActionPlan(id){
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
          title: AppConstants.TitleModal.DELETE_SENSOR_TYPE_DERIVATION_ACTIONPLAN,
          message: AppConstants.MessageModal.DELETE_CONFIRMATION_MESSAGE,
          hasButton: true,
          contentButton: {
              yes: 'SI',
              no: 'CANCELAR'
          }
      },
  })

  dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteActionPlan(id);
      }
  });
  }

deleteActionPlan(id: number) {
  this.sensorTypeService.deleteDeviationActionPlan(id).subscribe(() => {
    this.loadCausasAndPlanes(this.editItem.id);
  });
}
}
